// eslint-disable-next-line import/no-unresolved
import auth from '@/middleware/auth'

const formTable = [
  // CREATIONS
  {
    path: '/edades-cars/list',
    name: 'edades-cars-list',
    // eslint-disable-next-line import/no-unresolved
    component: () => import('@/views/nomencladores/cars/Edades.vue'),
    meta: {
      layout: 'content',
      middleware: auth,
      pertenece: 'nom_edades_cars',
    },
  },
]

export default formTable
